import React from 'react';
import { Zap, UserCheck, Crown } from 'lucide-react';
import { uvpFeatures } from '../mockData';

const iconMap = {
  Zap: Zap,
  UserCheck: UserCheck,
  Crown: Crown
};

const EarlyAccess = () => {
  return (
    <section className="early-access-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Why Riders Choose Us</h2>
          <p className="section-subtitle">
            More than just a showroom – your trusted partner in rider safety
          </p>
        </div>

        <div className="bento-grid">
          {uvpFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id} 
                className={`bento-card ${index === 0 ? 'bento-card-large' : ''}`}
              >
                <div className="bento-icon">
                  <Icon size={32} />
                </div>
                <h3 className="bento-title">{feature.title}</h3>
                <p className="bento-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EarlyAccess;
